var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "ReferraDepartment-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 60,
                            label: "名称",
                            prop: "name",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入名称",
                              maxlength: "125",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 60,
                            label: "状态",
                            prop: "status",
                          },
                        },
                        [
                          _c(
                            "RadioGroup",
                            {
                              attrs: { prop: "status" },
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Radio",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }